export default class Popup {
  constructor() {
		this.getDomElements()

    if (!this.dom.triggers.length || !this.dom.popup || !this.dom.close) return
    
    this.popupOpen = false

    this.handleClickEvents()
  }


  getDomElements() {
    this.dom = {
      triggers : document.querySelectorAll('.js-fabric-popup-trigger'),
      popup : document.querySelector('.js-fabric-popup'),
      close : document.querySelector('.js-fabric-popup-close'),
    }
  }

  handleClickEvents() {
    this.dom.popup.addEventListener('click', () => {
      if (this.popupOpen) { 
        this.dom.popup.classList.remove('isActive')
        this.popupOpen = false
      }
    })

    this.dom.popup.querySelector('.js-fabric-popup-inner').addEventListener('click', (e) => {
      e.stopPropagation()
    })

    this.dom.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        this.dom.popup.classList.add('isActive')
        this.popupOpen = true
      })
    })

    this.dom.close.addEventListener('click', () => {
      this.dom.popup.classList.remove('isActive')
      this.popupOpen = false
    })
  }
}